import { render, staticRenderFns } from "./ProspectiveReceivableUpload.vue?vue&type=template&id=0c24caa4&scoped=true&"
import script from "./ProspectiveReceivableUpload.vue?vue&type=script&lang=js&"
export * from "./ProspectiveReceivableUpload.vue?vue&type=script&lang=js&"
import style0 from "./ProspectiveReceivableUpload.vue?vue&type=style&index=0&id=0c24caa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c24caa4",
  null
  
)

export default component.exports